import { useOutletContext } from "react-router-dom";
import { useState } from "react";
import CompaniesTable from "../../components/adminDashboard/ui/companies/CompaniesTables.jsx";
import CompanyDetail from "../../components/adminDashboard/ui/companies/CompanyDetail.jsx";
import CompanyOnboarding from "../../components/adminDashboard/ui/companies/CompanyOnboarding.jsx";

export default function Companies() {
  const {
    companiesData,
    searchQuery,
    setSearchQuery,
    isOnboarding,
    selectedCompany,
    setSelectedCompany,
    onboardStep,
    setOnboardStep,
    handleFinishCompanyOnboarding,
    setIsOnboarding,
    getCompanyList
  } = useOutletContext();

  const [viewOnly, setViewOnly] = useState(false);

  const handleSelect = (company, isViewOnly) => {
    setSelectedCompany(company);
    setViewOnly(isViewOnly);
  };

  return (
    <>
      {!isOnboarding && !selectedCompany && (
        <CompaniesTable
          companies={companiesData}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onSelect={handleSelect}
          isOnboarding={setIsOnboarding}
          getCompanyList={getCompanyList}
        />
      )}
      {(isOnboarding || selectedCompany) && (
        <CompanyOnboarding
          step={onboardStep}
          setStep={setOnboardStep}
          onFinish={handleFinishCompanyOnboarding}
          selectedCompanyDetails={selectedCompany}
          viewOnly={viewOnly}
          onEnableEdit={() => setViewOnly(false)}
        />
      )}
    </>
  );
}
